export default {
    'name': 'figures',
    'label': 'patent-view.images',
    'getComponent': () => import('./dual-figures.vue'),
    'tabIndex': 4,
    'left': true,
    'right': true,
    'singleView': false,
    'compareView': true,
    'selfHandelPadding': true,
};
